// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (c) 2022 Imixs Software Solutions GmbH,
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 3
 * of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU
 * General Public License for more details.
 *
 * You can receive a copy of the GNU General Public
 * License at http://www.gnu.org/licenses/gpl.html
 *
 * Project:
 *     https://github.com/imixs/open-bpmn
 *
 * Contributors:
 *     Imixs Software Solutions GmbH - Project Management
 *     Ralph Soika - Software Developer
 ********************************************************************************/
.tool-palette {
    z-index: 10;
}

.bpmn-property-panel {
    position: absolute;
    bottom: 0px;
    z-index: 20;
    width: 100%;
    background: var(--theia-editor-background);
    opacity: 0.98 !important;
    color: var(--theia-editor-foreground);
    height: 28px;
}

/* theia-editorWidget-background */
.bpmn-property-header {
    padding-left: 8px;
    background: var(--theia-titleBar-activeBackground);
    color: var(--theia-titleBar-activeForeground);
    opacity: 1;
    font-weight: bold;
    border: 0;
    overflow: hidden;
    padding: 2px 5px 3px 5px;
    line-height: 1.5em;
    box-shadow: none;
    border-top: 3px solid var(--theia-focusBorder);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    cursor: row-resize;
}

.bpmn-property-header .header-icon i {
    padding-left: 4px;
    padding-right: 4px;
}

.bpmn-property-header .header-tools {
    cursor: default;
}

.bpmn-property-header .header-tools i {
    border: none;
}

.bpmn-property-header .header-tools i:hover:not(.clicked) {
    background: var(--theia-menubar-selectionBackground);
}

.bpmn-property-header .header-tools .clicked,
.bpmn-property-header .header-tools i:hover {
    background: none;
    border: none;
}

.bpmn-property-header .header-icon span::first-letter {
    text-transform: capitalize;
}


/* Scrollbar behavior in property details block */
.bpmn-properties-body {
    height: 100%;
}

.bpmn-properties-body .categorization {
    height: 100%;
}

.bpmn-properties-body .categorization-master {
    background: var(--theia-titleBar-activeBackground);
}

.categorization>.categorization-master ul li.selected>span {
    color: var(--theia-sideBar-foreground);
    background: var(--theia-sideBar-background);
}

.bpmn-properties-body .categorization-detail {
    overflow: auto;
    margin-bottom: 28px;
}

/* Button layout in property details block */
.bpmn-properties-body .categorization-detail button {
    float: right;
    color: var(--theia-button-foreground);
    background-color: var(--theia-button-background);
    cursor: pointer;
    border: none;
    padding: 4px 9px;
    margin: 0 1px;
}

.bpmn-properties-body .categorization-detail button:focus {
    outline: 1px solid var(--theia-focusBorder);
    outline-offset: 1px;
}

.bpmn-properties-body .categorization-detail button:hover {
    background-color: var(--theia-button-hoverBackground);
}

.bpmn-properties-body .categorization-detail .child-controls {
    float: right;
    border-bottom: 1px solid #aaa;
    width: 100%;
    padding-bottom: 5px;
}

.bpmn-properties-body .categorization-detail .vertical-layout {
    clear: both;
}

/* Custom BPMN Styles **/
.bpmn-properties-body .control>textarea {
    min-height: 14rem !important;
}

.bpmn-properties-body .control.text-file-editor>label {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
}

.bpmn-properties-body .control.text-file-editor>label .file-selector {
    font-weight: bold;
    color: var(--theia-focusBorder);
}

.bpmn-properties-body .control.text-file-editor>textarea {
    min-height: 22rem !important;
}

.bpmn-properties-body .control.text-file-editor>textarea.fileInputMode {
    min-height: 1em !important;
    line-height: 1.5rem;
}

.input-description {
    color: #666;
    font-size: var(--theia-ui-font-size0) !important;
    line-height: 1.4rem;
    margin-left: 3px;
}`, "",{"version":3,"sources":["webpack://./../open-bpmn-properties/css/bpmn-properties.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;iFAsBiF;AACjF;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,0CAA0C;IAC1C,wBAAwB;IACxB,qCAAqC;IACrC,YAAY;AAChB;;AAEA,kCAAkC;AAClC;IACI,iBAAiB;IACjB,kDAAkD;IAClD,6CAA6C;IAC7C,UAAU;IACV,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,8CAA8C;IAC9C,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA,iDAAiD;AACjD;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,sCAAsC;IACtC,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,4CAA4C;AAC5C;IACI,YAAY;IACZ,qCAAqC;IACrC,gDAAgD;IAChD,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA,wBAAwB;AACxB;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gDAAgD;IAChD,mBAAmB;IACnB,gBAAgB;AACpB","sourcesContent":["/********************************************************************************\n * Copyright (c) 2022 Imixs Software Solutions GmbH,\n *\n * This program is free software; you can redistribute it and/or\n * modify it under the terms of the GNU General Public License\n * as published by the Free Software Foundation; either version 3\n * of the License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU\n * General Public License for more details.\n *\n * You can receive a copy of the GNU General Public\n * License at http://www.gnu.org/licenses/gpl.html\n *\n * Project:\n *     https://github.com/imixs/open-bpmn\n *\n * Contributors:\n *     Imixs Software Solutions GmbH - Project Management\n *     Ralph Soika - Software Developer\n ********************************************************************************/\n.tool-palette {\n    z-index: 10;\n}\n\n.bpmn-property-panel {\n    position: absolute;\n    bottom: 0px;\n    z-index: 20;\n    width: 100%;\n    background: var(--theia-editor-background);\n    opacity: 0.98 !important;\n    color: var(--theia-editor-foreground);\n    height: 28px;\n}\n\n/* theia-editorWidget-background */\n.bpmn-property-header {\n    padding-left: 8px;\n    background: var(--theia-titleBar-activeBackground);\n    color: var(--theia-titleBar-activeForeground);\n    opacity: 1;\n    font-weight: bold;\n    border: 0;\n    overflow: hidden;\n    padding: 2px 5px 3px 5px;\n    line-height: 1.5em;\n    box-shadow: none;\n    border-top: 3px solid var(--theia-focusBorder);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    cursor: row-resize;\n}\n\n.bpmn-property-header .header-icon i {\n    padding-left: 4px;\n    padding-right: 4px;\n}\n\n.bpmn-property-header .header-tools {\n    cursor: default;\n}\n\n.bpmn-property-header .header-tools i {\n    border: none;\n}\n\n.bpmn-property-header .header-tools i:hover:not(.clicked) {\n    background: var(--theia-menubar-selectionBackground);\n}\n\n.bpmn-property-header .header-tools .clicked,\n.bpmn-property-header .header-tools i:hover {\n    background: none;\n    border: none;\n}\n\n.bpmn-property-header .header-icon span::first-letter {\n    text-transform: capitalize;\n}\n\n\n/* Scrollbar behavior in property details block */\n.bpmn-properties-body {\n    height: 100%;\n}\n\n.bpmn-properties-body .categorization {\n    height: 100%;\n}\n\n.bpmn-properties-body .categorization-master {\n    background: var(--theia-titleBar-activeBackground);\n}\n\n.categorization>.categorization-master ul li.selected>span {\n    color: var(--theia-sideBar-foreground);\n    background: var(--theia-sideBar-background);\n}\n\n.bpmn-properties-body .categorization-detail {\n    overflow: auto;\n    margin-bottom: 28px;\n}\n\n/* Button layout in property details block */\n.bpmn-properties-body .categorization-detail button {\n    float: right;\n    color: var(--theia-button-foreground);\n    background-color: var(--theia-button-background);\n    cursor: pointer;\n    border: none;\n    padding: 4px 9px;\n    margin: 0 1px;\n}\n\n.bpmn-properties-body .categorization-detail button:focus {\n    outline: 1px solid var(--theia-focusBorder);\n    outline-offset: 1px;\n}\n\n.bpmn-properties-body .categorization-detail button:hover {\n    background-color: var(--theia-button-hoverBackground);\n}\n\n.bpmn-properties-body .categorization-detail .child-controls {\n    float: right;\n    border-bottom: 1px solid #aaa;\n    width: 100%;\n    padding-bottom: 5px;\n}\n\n.bpmn-properties-body .categorization-detail .vertical-layout {\n    clear: both;\n}\n\n/* Custom BPMN Styles **/\n.bpmn-properties-body .control>textarea {\n    min-height: 14rem !important;\n}\n\n.bpmn-properties-body .control.text-file-editor>label {\n    width: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.bpmn-properties-body .control.text-file-editor>label .file-selector {\n    font-weight: bold;\n    color: var(--theia-focusBorder);\n}\n\n.bpmn-properties-body .control.text-file-editor>textarea {\n    min-height: 22rem !important;\n}\n\n.bpmn-properties-body .control.text-file-editor>textarea.fileInputMode {\n    min-height: 1em !important;\n    line-height: 1.5rem;\n}\n\n.input-description {\n    color: #666;\n    font-size: var(--theia-ui-font-size0) !important;\n    line-height: 1.4rem;\n    margin-left: 3px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
